import { css } from '@emotion/react';
import { Button } from '@zapier/marketing-ui';
import { Icon } from '@zapier/zinnia-icons';
import { FC } from 'react';
import { EmailMessage } from './EmailMessage';

type Props = {
  email: string;
  onClick: () => void;
};

const backLinkTextStyles = css`
  display: flex;
  align-items: center;
  gap: 2px;
`;

const PasswordHeader: FC<Props> = ({ email, onClick }) => {
  return (
    <>
      <Button variant="plain" hasArrow={false} onClick={onClick}>
        <div css={backLinkTextStyles}>
          <Icon name="arrowBigLeft" size={20} /> Back
        </div>
      </Button>
      <EmailMessage email={email} />
    </>
  );
};

export default PasswordHeader;
